"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const react_1 = require("react");
const icon_button_1 = require("../../component/input/icon-button");
exports.ActionButton = (0, react_1.memo)(({ onClick, icon, isCompleted, enabled = true, eventName, }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(StyledBadge, { badgeContent: isCompleted ? ((0, jsx_runtime_1.jsx)(icons_material_1.CheckCircle, { sx: {
                fontSize: theme.spacing(2),
            }, color: "success" })) : undefined, anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
        }, children: (0, jsx_runtime_1.jsx)(icon_button_1.IconButton, { sx: {
                width: theme.spacing(8),
                height: theme.spacing(8),
                backgroundColor: "white",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                transition: "background-color 0.2s ease-in-out",
                "&:hover": {
                    transform: "scale(1.1)",
                },
            }, eventName: eventName, onClick: onClick, disabled: !enabled, children: (0, jsx_runtime_1.jsx)(material_1.SvgIcon, { component: icon }) }) }));
});
exports.ActionButton.displayName = "ActionButton";
const StyledBadge = (0, material_1.styled)(material_1.Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
        bottom: theme.spacing(1),
        right: theme.spacing(1),
    },
}));
